import { render, staticRenderFns } from "./ProviderLastPurchases.vue?vue&type=template&id=67073625"
import script from "./ProviderLastPurchases.vue?vue&type=script&lang=js"
export * from "./ProviderLastPurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports